<script>
    import { createEventDispatcher } from "svelte";
    // import ModalConfirm from "../../components/modalconfirm.svelte";
    import Modal from "../../components/modal.svelte";
    import Button from "../../components/button.svelte";
    import Tooltip from "../../components/tooltip.svelte";
    import DataTable from "../../../components/data-table.svelte";
    export let selectedUser;
    export let showModal;

    let bid;
    const dispatch = new createEventDispatcher();
    export let matchedUsers = [];

    export let isButtonLoading = false;
    export let isMatchButtonLoading = [];
    export let isPageLoading = false;
    export let role;
    let confirmMessage = "";
    // let confirmModalHeader = "";
    // let pupilTransferType = "";
    // let matchedStaff;
    // let matchedUser;
    // let showConfirmModal = false;
    // let actionType = "";
    let resultMessage = "";
    let addButtonText = "";
    let transferButtonText = "";


    const onStartUp = () => {
        if (role == "Staff") {
            addButtonText = "Add Association";
            transferButtonText = "Request Transfer";
        }
        if (role == "Pupil") {
            addButtonText = "Match & Add";
            transferButtonText = "Match & Transfer";
        }
    };
    onStartUp();

    const getConfirmMessage = (u, action, messageType) => {
        let messageBody = "";
        let messageHeader = "";
        if (action == "add") {
            if (role == "Staff") {
                messageBody = `${confirmMessage}  ${u.addConfirmMessage}`;
                messageHeader = "Add Association?";
            }
            if (role == "Pupil") {
                messageBody = `<p>Are you sure you would like to add account for <b>${selectedUser.firstName} ${selectedUser.lastName} </b>?</p>`;
                messageHeader = "Add Pupil?";
            }
        }
        if (action == "transfer") {
            if (role == "Staff") {
                messageBody = `${confirmMessage}  ${u.transferConfirmMessage}`;
                messageHeader = "Request Transfer";
            }
            if (role == "Pupil") {
                messageBody = `<p>Are you sure you would like to transfer account for <b>${selectedUser.firstName} ${selectedUser.lastName} </b>?</p>`;
                messageHeader = "Transfer Pupil?";
            }
        }
        if (messageType == "messageBody") return messageBody;
        else if (messageType == "messageHeader") return messageHeader;
    };


    // const matchStaff = async (user) => {
    //     resultMessage = "";
    //     isMatchButtonLoading = true;
    //     let result = await onMatch(user, bid);
    //     isMatchButtonLoading = false;
    //     resultMessage = result ? result.message : "";
    //     if (result && result.success) {
    //         showModal = false;
    //         showResultModal = true;
    //     }
    // };

    const onHandleConfirm = async (u, action, i ) => {
        //  matchedUser = u;
        // actionType = action;
        dispatch("confirm", { u, action, i  });
        // if (actionType == "addStaff" || actionType == "transferStaff")
        //     await requestAddTransfer();
    };

    function dispatchOptions(event, button, type){
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        if (!event.target.matches('.' + button)) return;
        let str = event.target.getAttribute('data');
        const myArr = str.split("-");
        isMatchButtonLoading[myArr[1]] = true;
        u = matchedUsers.find(x => x.personId === (parseInt(myArr[0])));
        dispatch('confirm', { u: u, action: type, i: myArr[1] });


        
    }

    document.addEventListener('click', function (event) {
        dispatchOptions(event, 'MatchUserbtn', 'match');
    }, false);

    document.addEventListener('click', function (event) {
        dispatchOptions(event, 'AddMatchUserbtn', 'add');
    }, false);

    document.addEventListener('click', function (event) {
        dispatchOptions(event, 'TransferMatchUserbtn', 'transfer');
    }, false);
        
    document.addEventListener('click', function (event) {
        dispatchOptions(event, 'AddNotStaffMatchUserbtn', 'add');
    }, false);

    document.addEventListener('click', function (event) {
        dispatchOptions(event, 'TransferNotStaffMatchUserbtn', 'transfer');
    }, false);
   

    let columnDefs = [
        { type: "date-euro", targets: [2] },
        { orderable: false, targets: [6] },
    ];

    
</script>

<Modal
    {showModal}
    on:close={() => {
        resultMessage = '';
        showModal = false;
    }}
    bind:isPageLoading
    targetClass="match-options"
    zindex="1051">
    <div slot="header">
        <h4 class="title">Create a new account or match an existing one</h4>
    </div>
    <div slot="content">
        <div class="card">
            <div class="card-header">
                <h5 style="margin-bottom:0">Selected {role}</h5>
            </div>
            <div class="card-body">
                <div class="row" style="margin-bottom: 2px;">
                    <div class="col-lg-6">
                        <label for="firstName"><b>First Name:</b></label>&nbsp;<span>{selectedUser.firstName}</span>
                    </div>
                    {#if role == "Pupil"}
                        <div class="col-lg-6">
                            <label
                                for="upn"><b>UPN:</b></label>&nbsp;<span>{selectedUser.upn || ''}</span>
                        </div>
                    {/if}
                    <div class="col-lg-6">
                        <label for="lastName"><b>Last Name:</b></label>&nbsp;<span>{selectedUser.lastName}</span>
                    </div>

                    <div class="col-lg-6">
                        <label for="dob"><b>Date of Birth:</b></label>&nbsp;<span>{selectedUser.birth}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mt-3">
                        <Button
                            bind:isLoading={isButtonLoading}
                            style={'width:147.5px;'}
                            title={'Create a new username and password for the selected member of staff.'}
                            buttonClass={'btn-primary float-left'}
                            buttonText={'Create New'}
                            isConfirm={true}
                            popupTitle={'Are you sure you would like to create this user?'}   
                            on:confirmPopup={() => dispatch('create')} />
                        {#if matchedUsers.length > 0}
                            <span style="display:inline-block;padding:0.5rem;">
                                OR MATCH BELOW</span>
                        {/if}                      
                    </div>
                    {#if resultMessage != ''}
                        <div class="row">
                            <div class="col-lg-12">
                                <span class="text-danger">{resultMessage}</span>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>

        <br />
        {#if matchedUsers.length > 0}
            <!-- <p><b>Or Possible Matches</b></p> -->
            <div class="card">
                <div class="card-header">
                    <h5 style="margin-bottom:0">Matches</h5>
                </div>
                <div class="card-body">
                    <DataTable {columnDefs} DataLength={matchedUsers.length} ResponsiveHeader='0,1'>
                        <thead>
                            <tr style="background-color:rgba(0, 0, 0, 0.03)">
                                <!-- <th><b>First Name</b></th>
                                <th><b>Last Name</b></th> -->
                                <th><b>Name</b></th>
                                <th><b>Username</b></th>
                                <th>
                                    <b>
                                        <!--{#if role == 'Staff'}Birth Year{:else}Date of Birth{/if}-->
                                    Date of Birth
                                    </b>
                                </th>
                                <th><b>School</b></th>
                                {#if role == "Pupil"}
                                    <th><b>UPN</b></th>
                                {/if}
                                <th><b>Gender</b></th>
                                <th><b>Reason</b></th>
                                <th><b>Action</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each matchedUsers as u,i}
                                <tr>
                                    <td>{u.firstName} {u.lastName}</td>
                                    {#if role == "Pupil"}
                                        <td>{u.userID}</td>
                                    {:else}
                                        <td>{u.universalId}</td>
                                    {/if}
                                    <td>
                                       <!-- {#if role == 'Staff'}
                                            {u.birthYear || ''}
                                        {:else}{u.birth || ''}{/if}-->
                                        {u.birth || ''}
                                    </td>
                                    <td>{u.estab || ''}</td>
                                    {#if role == "Pupil"}
                                        <td>{u.upn || ''}</td>
                                    {/if}
                                    <td>{u.gender || ''}</td>
                                    <td><span class="text-danger">{u.reason}</span></td>
                                    <td>
                                        {#if u.role == 'Staff' && u.showMatchButton}
                                            <!--<a
                                                class="btn btn-grey MatchUserbtn"
                                                href="#"
                                                isConfirm={true}
                                                data={u.personId + '-' + i}
                                                popupTitle={'Are you sure you would like to match this user?'}                                              
                                                on:confirmPopup={() => {
                                                    isMatchButtonLoading[i] = true;
                                                    dispatch('confirm', {
                                                        u: u,
                                                        action: 'match',
                                                        i: i
                                                    });
                                                }}>
                                                Match</a> -->
                                             
                                            <Button
                                                buttonClass={'btn-grey btn-sm MatchUserbtn'}
                                                buttonStyle={'height:35px;'}
                                                buttonText={'Match'}
                                                isConfirm={true}
                                                dataid={u.personId + '-' + i}
                                                popupTitle={'Are you sure you would like to match this user?'}                                              
                                                on:confirmPopup={() => {
                                                    isMatchButtonLoading[i] = true;
                                                    dispatch('confirm', {
                                                        u: u,
                                                        action: 'match',
                                                        i: i
                                                    });
                                                }} />
                                         
                                        {/if}
                                        {#if u.showAddButton && u.showTransferButton}
                                            <div style="display:flex"> 
                                                 <Button
                                                    buttonClass={'btn-grey AddMatchUserbtn btn-sm mr-2'}
                                                    buttonStyle={'height:35px;width:135px;'}
                                                    buttonText={addButtonText}
                                                    bind:isLoading={isMatchButtonLoading[i]}
                                                    isConfirm={true}
                                                    dataid={u.personId + '-' + i}
                                                    popupText={getConfirmMessage(u, 'add', 'messageBody')}
                                                    popupTitle={getConfirmMessage(u, 'add', 'messageHeader')}
                                                    hoverText="Match the highlighted pupil with the pupil selected at the top of the page, and add a new association for the pupil at your establishment."
                                                    on:confirmPopup={() => {
                                                        isMatchButtonLoading[i] = true;
                                                        onHandleConfirm(u,'add',i);
                                                    }} />                                              
                                                <Tooltip stopPropagate={true}>   
                                                                                                                    
                                                        <Button
                                                            buttonClass={'btn-grey TransferMatchUserbtn btn-sm mr-2'}
                                                            buttonStyle={'height:35px;'}
                                                            confirmButtonStyle={'width: 147.5px;margin-top: 5px;margin-left:-70px;'}
                                                            buttonText={transferButtonText}                                                           
                                                            bind:isLoading={isMatchButtonLoading[i]}
                                                            isConfirm={true}
                                                            dataid={u.personId + '-' + i}
                                                            popupText={getConfirmMessage(u, 'transfer', 'messageBody')}
                                                            popupTitle={getConfirmMessage(u, 'transfer', 'messageHeader')}
                                                            hoverText="Match the highlighted pupil with the selected pupil at the top of the page, and transfer the USO account if it is currently associated with a different establishment."
                                                            on:confirmPopup={() => {
                                                                isMatchButtonLoading[i] = true;
                                                                onHandleConfirm(u,'transfer',i);
                                                            }} />                                                  
                                                </Tooltip>
                                            </div>
                                        {:else}
                                            {#if u.showAddButton}  
                                                    <Button
                                                        buttonClass={'btn-grey AddNotStaffMatchUserbtn btn-sm mr-2'}
                                                        buttonStyle={'height:35px;'}
                                                        buttonText={addButtonText}
                                                        isConfirm={true}
                                                        dataid={u.personId + '-' + i}
                                                        popupText={getConfirmMessage(u, 'add', 'messageBody')}
                                                        popupTitle={getConfirmMessage(u, 'add', 'messageHeader')}
                                                        hoverText="Match the highlighted pupil with the pupil selected at the top of the page, and add a new association for the pupil at your establishment."
                                                        bind:isLoading={isMatchButtonLoading[i]}
                                                        on:confirmPopup={() => {
                                                             isMatchButtonLoading[i] = true;
                                                             onHandleConfirm(u,'add',i);
                                                        }} />                                               
                                            {/if}
                                            {#if u.showTransferButton}
                                                    <Button
                                                        buttonClass={'btn-grey TransferNotStaffMatchUserbtn btn-sm mr-2'}
                                                        buttonStyle={'height:35px;'}
                                                        buttonText={transferButtonText} 
                                                        dataid={u.personId + '-' + i}
                                                        isConfirm={true}                                                      
                                                        bind:isLoading={isMatchButtonLoading[i]}
                                                        popupText={getConfirmMessage(u, 'transfer', 'messageBody')}
                                                        popupTitle={getConfirmMessage(u, 'transfer', 'messageHeader')}
                                                        hoverText="Match the highlighted pupil with the selected pupil at the top of the page, and transfer the USO account if it is currently associated with a different establishment."
                                                        on:confirmPopup={() => {
                                                             isMatchButtonLoading[i] = true;
                                                            onHandleConfirm(u,'transfer',i);
                                                        }} />                                                
                                            {/if}
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </DataTable>
                </div>
            </div>
        {/if}
    </div>
</Modal>

<!-- <ModalConfirm
    bind:showModal={showConfirmModal}
    zindex="1052"
    sizeClass="modal-lg"
    targetClass="confirm-options"
    bind:isButtonLoading={isMatchButtonLoading}
    on:confirm={onHandleConfirm}
    on:show={() => jQuery('.modal-backdrop.show:last').css('z-index', '1051')}>
    <div slot="header">
        <h4 class="title">{confirmModalHeader}</h4>
    </div>
    <div slot="content">
        {@html confirmMessage}
    </div>
</ModalConfirm> -->
